import React from "react";
import { withRouter, Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, RadialLinearScale, CategoryScale, LinearScale, PointElement, LineElement, Title, Filler, BarElement,
  LineController,
  BarController
} from 'chart.js';
import { Pie, Bar, Line } from 'react-chartjs-2';
import ProgressBar from 'react-bootstrap/ProgressBar';
import {Helmet} from "react-helmet";

import Footer from "../../components/Footer/footer";
import "./dashboard.css"

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Title, Filler, BarElement,
  LineController,
  BarController
  );

export const pieOptions = {
  plugins: {
    legend: {
      display: false,
    },
  },
};

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top'
    }
  },
};

const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const emptyData = {
  labels,
  datasets: [
    {
      type: 'line',
      label: ' No. of Candidates Trained',
      borderColor: 'rgba(13, 96, 160, 1)',
      borderWidth: 2,
      fill: false,
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    {
      type: 'bar',
      label: ' No. of Workshops Conducted',
      backgroundColor: 'rgb(255, 99, 132)',
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], 
      borderColor: 'white',
      borderWidth: 2,
    },
    {
      type: 'bar',
      label: ' No. of Trainings Conducted',
      backgroundColor: 'rgba(13, 96, 160, 1)',
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], 
      borderColor: 'white',
      borderWidth: 2,
    }
  ],
};

class dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      yearSwitch: "2022",
      genderCount: [0, 0, 0],

      cad_cam: 0,
      digitalLiteracy: 0,
      digitalPhotography: 0,
      entrepreneurship: 0,
      it_skills: 0,
      handloomWorkshop: 0,

      cad_cam_percentage: 0,
      digitalLiteracy_percentage: 0,
      digitalPhotography_percentage: 0,
      entrepreneurship_percentage: 0,
      it_skills_percentage: 0,
      handloomWorkshop_percentage: 0,
      total_percentage: 0,

      districtData: [],
      timelineData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    };
  }
  componentDidMount(){
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    this.getGenderData();
    this.getTimelineData("2022");
    this.getTrainingData();
    this.getDistricData();
  }
  getGenderData = () => {
    fetch(`https://dihh.nielitkohima.in/admin/api/genderWise.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log("OUTPUT ==> ", responseJson);

        let responseArray = [];
        responseArray = responseJson;
        let genderCount = [0, 0, 0];

        let females = 0;
        let f = 0;

        //For Females
        let female_count = responseArray.findIndex(element => element.gender.includes("Female"));
        if(female_count != -1){
          females = females +  Number(responseArray[female_count].Total)
        }

        /*let f_count = responseArray.findIndex(element => element.gender.includes("F"));
        if(f_count != -1){
          f = f +  Number(responseArray[f_count].Total)
        }*/

        if(females > 0 || f >0){
          genderCount[1] = females + f
        }
        
        //For Males
        let males = 0;
        let m = 0;

        let male_count = responseArray.findIndex(element => element.gender.includes("Male"));
        if(male_count != -1){
          males = males +  Number(responseArray[male_count].Total)
        }

        /*let m_count = responseArray.findIndex(element => element.gender.includes("M"));
        if(m_count != -1){
          m = m +  Number(responseArray[m_count].Total)
        }*/

        if(males > 0 || m > 0){
          genderCount[0] = males + m
        }

        this.setState({
          genderCount: genderCount
        })
      })
      .catch((error) => {
        console.error(error);
      });
  };
  getTrainingData = () => {
    fetch(`https://dihh.nielitkohima.in/admin/api/training_categoryWise.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log("Training Data ==> ", responseJson);
        
        if(responseJson[0]){
          this.setState({
            cad_cam: Number(responseJson[0].Total)
          })
        }
        if(responseJson[1] && responseJson[1].training_name === "Awareness Workshop"){
          this.setState({
            handloomWorkshop: Number(responseJson[1].Total)
          })
        }
        if(responseJson[2] && responseJson[2].training_name === "Digital Literacy"){
          this.setState({
            digitalLiteracy: Number(responseJson[2].Total)
          })
        }
        if(responseJson[3] && responseJson[3].training_name === "Digital Photography and Scanning"){
          this.setState({
            digitalPhotography: Number(responseJson[3].Total)
          })
        }
        if(responseJson[4] && responseJson[4].training_name === "Entrepreneurship & Soft Skill development"){
          this.setState({
            entrepreneurship: Number(responseJson[4].Total)
          })
        }
        if(responseJson[5] && responseJson[5].training_name === "IT based Capacity Building for Different Crafts"){
          this.setState({
            it_skills: Number(responseJson[5].Total)
          })
        }
        setTimeout(() => {
          this.getProgressPercentage();
        }, 1500);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  getProgressPercentage = () => {
    let {handloomWorkshop, handloomWorkshop_percentage, cad_cam, digitalLiteracy, digitalPhotography, entrepreneurship, it_skills, cad_cam_percentage, digitalLiteracy_percentage, digitalPhotography_percentage, entrepreneurship_percentage, it_skills_percentage, total_percentage} = this.state;
    cad_cam_percentage = Math.round(((cad_cam/200)*100) * 10)/10;
    digitalLiteracy_percentage = Math.round(((digitalLiteracy/4000)*100) * 10)/10;
    digitalPhotography_percentage = Math.round(((digitalPhotography/400)*100) * 10)/10;
    entrepreneurship_percentage = Math.round(((entrepreneurship/380)*100) * 10)/10;
    it_skills_percentage = Math.round(((it_skills/940)*100) * 10)/10;
    handloomWorkshop_percentage =  Math.round(((handloomWorkshop/1000)*100) * 10)/10;

    let total = (cad_cam + digitalLiteracy + digitalPhotography + entrepreneurship + it_skills + handloomWorkshop);
    total_percentage = Math.round(((total/6920)*100) * 10)/10;
    console.log(total_percentage)
    this.setState({
      digitalLiteracy_percentage,
      cad_cam_percentage,
      total_percentage,
      handloomWorkshop_percentage,
      digitalPhotography_percentage,
      entrepreneurship_percentage,
      it_skills_percentage
    })
  }
  getDistricData = () => {
    fetch(`https://dihh.nielitkohima.in/admin/api/training_districtWise.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log("District Data ==> ", responseJson);
        let filteredArray = responseJson.filter(item => Number(item.Total) >= 1);
        let totals = filteredArray.map(entry => entry.Total.toString());;
        console.log("District TOTALS ==>", totals);
        this.setState({
          districtData: totals
        })
      })
      .catch((error) => {
        console.error(error);
      });
      
  }
  getTimelineData = (year) => {
    fetch(`https://dihh.nielitkohima.in/admin/api/get_year_month_wise_artisans.php?year=`+year, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((responseJson) => {
        let timelineData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        console.log("Timeline Data ==> ", responseJson);
        let responseArray = [];
        responseArray = responseJson;

        let January = responseArray.findIndex(element => element.Month.includes("January"));
        if(January != -1){
          timelineData[0] = timelineData[0] + Number(responseArray[January].Total_Artisans)
        }

        let February = responseArray.findIndex(element => element.Month.includes("February"));
        if(February != -1){
          timelineData[1] = timelineData[1] + Number(responseArray[February].Total_Artisans)
        }

        let March = responseArray.findIndex(element => element.Month.includes("March"));
        if(March != -1){
          timelineData[2] = timelineData[2] + Number(responseArray[March].Total_Artisans)
        }

        let April = responseArray.findIndex(element => element.Month.includes("April"));
        if(April != -1){
          timelineData[3] = timelineData[3] + Number(responseArray[April].Total_Artisans)
        }

        let May = responseArray.findIndex(element => element.Month.includes("May"));
        if(May != -1){
          timelineData[4] = timelineData[4] + Number(responseArray[May].Total_Artisans)
        }

        let June = responseArray.findIndex(element => element.Month.includes("June"));
        if(June != -1){
          timelineData[5] = timelineData[5] + Number(responseArray[June].Total_Artisans)
        }

        let July = responseArray.findIndex(element => element.Month.includes("July"));
        if(July != -1){
          timelineData[6] = timelineData[6] + Number(responseArray[July].Total_Artisans)
        }

        let August = responseArray.findIndex(element => element.Month.includes("August"));
        if(August != -1){
          timelineData[7] = timelineData[7] + Number(responseArray[August].Total_Artisans)
        }

        let September = responseArray.findIndex(element => element.Month.includes("September"));
        if(September != -1){
          timelineData[8] = timelineData[8] + Number(responseArray[September].Total_Artisans)
        }
        
        let October = responseArray.findIndex(element => element.Month.includes("October"));
        if(October != -1){
          timelineData[9] = timelineData[9] + Number(responseArray[October].Total_Artisans)
        }

        let November = responseArray.findIndex(element => element.Month.includes("November"));
        if(November != -1){
          timelineData[10] = timelineData[10] + Number(responseArray[November].Total_Artisans)
        }

        let December = responseArray.findIndex(element => element.Month.includes("December"));
        if(December != -1){
          timelineData[11] = timelineData[11] + Number(responseArray[December].Total_Artisans)
        }
        this.setState({
          timelineData: timelineData
        })
      })
      .catch((error) => {
        console.error(error);
      });
      
  }
  toggleChart = (year) => {
    this.setState({yearSwitch: year})
    this.getTimelineData(year)
  }
  render() {
    return (
      <div>
        <Helmet>
          <html lang="en" />  
          <meta charSet="utf-8" />
          <title>NIELIT Kohima - Digital Intervention of Handloom and Handicraft | Dashboard</title>
          <meta name="description" content="The project 'Digital Intervention of Handicraft & Handloom' was commenced in the year 2021. Trainings for each of the sector are organised on monthly basis, which empowers the handicraft and handloom in the state of Nagaland as a pilot project initiated by the Ministry of Electronics and Information Technology, Govt. of India." />
          <link rel="canonical" href="https://nielitdihh.in/" />
        </Helmet>
        <div className="dashbaord_div_1">
          <div className="about_div_1_inner">
            <p className="dashbaord_div_1_inner_txt">Digital Intervention in Handicraft and Handloom</p>
            <p className="home_box_1_para_white">The project "Digital Intervention of Handicraft & Handloom" was commenced in the year 2021. Trainings for each of the sector are organised on monthly basis, which empowers the handicraft and handloom in the state of Nagaland as a pilot project initiated by the Ministry of Electronics and Information Technology, Govt. of India.</p>
            <button className="requestQuote">
              <a className="href_reports" href="#reports">View Reports</a>
            </button>
          </div>
        </div>
        <div className="dashbaord_div_2" id="reports">
          <Row>
            <Col md={6} xs={12} sm={12}>
              <div className="dashbaord_div_2_innerLeft">
                <Row>
                  <Col md={5} xs={12} sm={12}>
                    <div>
                      <p className="dashboard_pie_txt">Gender Wise Distribution</p>
                      <p className="dashboard_pie_subtxt">This pie chart represents the gender-wise distribution of the candidates being trained.</p>
                    </div>
                  </Col>
                  <Col md={7} xs={12} sm={12}>
                    <div>
                      <Pie data={{
                        labels: ['Men', 'Women', 'Transgender'],
                        datasets: [
                          {
                            label: 'Candidates',
                            data: this.state.genderCount,
                            backgroundColor: [
                              'rgba(0,104,182,255)',
                              'rgba(236,0,140,255)',
                              'rgba(235,237,239,255)'
                            ],
                            borderColor: [
                              'rgba(255, 255, 255, 1)',
                              'rgba(255, 255, 255, 1)',
                              'rgba(255, 255, 255, 1)'
                            ],
                            borderWidth: 1,
                          },
                        ]
                      }} options={pieOptions}/>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col md={6} xs={12} sm={12}>
              <div className="dashbaord_div_2_innerRight">
                <Row>
                  <Col md={5} xs={12} sm={12}>
                    <div>
                      <p className="dashboard_pie_txt">Training Wise Distribution</p>
                      <p className="dashboard_pie_subtxt">This pie chart represents the category-wise distribution of the candidates being trained, across 6 training programs.</p>
                    </div>
                  </Col>
                  <Col md={7} xs={12} sm={12}>
                    <div>
                      <Pie
                        data={{
                          labels: ['Digital Literacy', 'Digital Photography', 'CAD/CAM', 'IT based', 'Entrepreneurship & Soft Skill', "Awareness Workshop"],
                          datasets: [
                            {
                              label: 'Candidates',
                              data: [this.state.digitalLiteracy, this.state.digitalPhotography, this.state.cad_cam, this.state.it_skills, this.state.entrepreneurship, this.state.handloomWorkshop],
                              backgroundColor: [
                                'rgba(0,104,182,255)',
                                'rgba(163,103,220,255)',
                                'rgba(9,187,159,255)',
                                'rgba(24,161,205,255)',
                                'rgba(255,201,129,255)',
                                'rgba(236,0,140,255)',
                              ],
                              borderColor: [
                                'rgba(255, 255, 255, 1)',
                                'rgba(255, 255, 255, 1)',
                                'rgba(255, 255, 255, 1)',
                                'rgba(255, 255, 255, 1)',
                                'rgba(255, 255, 255, 1)',
                                'rgba(255, 255, 255, 1)',
                              ],
                              borderWidth: 1,
                            },
                          ],
                        }} options={pieOptions}/>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
        <div className="dashbaord_div_3">
          <div className="dashbaord_div_3_inner">
            <span className="dashboard_pie_txt_left">Timeline</span>
            {
              this.state.yearSwitch === "2025" ?
                <span className="dashboard_2022_txt_active">2025</span>
              :
                <span className="dashboard_2022_txt" onClick={() => this.toggleChart("2025")}>2025</span>
            }
            {
              this.state.yearSwitch === "2024" ?
                <span className="dashboard_2022_txt_active">2024</span>
              :
                <span className="dashboard_2022_txt" onClick={() => this.toggleChart("2024")}>2024</span>
            }
            {
              this.state.yearSwitch === "2023" ?
                <span className="dashboard_2022_txt_active">2023</span>
              :
                <span className="dashboard_2022_txt" onClick={() => this.toggleChart("2023")}>2023</span>
            }
            {
              this.state.yearSwitch === "2022" ?
                <span className="dashboard_2022_txt_first_active">2022</span>
              :
                <span className="dashboard_2022_txt_first" onClick={() => this.toggleChart("2022")}>2022</span>
            }
            <Line
              data={{
                labels,
                datasets: [
                  {
                    type: 'line',
                    label: ' No. of Candidates Trained',
                    borderColor: 'rgba(13, 96, 160, 1)',
                    backgroundColor: 'rgba(53, 162, 235, 0.5)',
                    borderWidth: 2,
                    tension: 0.4,
                    fill: true,
                    data: this.state.timelineData,
                  }
                ],
              }}
              options={{
                responsive: true
              }}
            />
          </div>
        </div>
        <div className="dashbaord_div_4">
          <div className="dashbaord_div_4_inner">
            <p className="dashboard_pie_txt">District Wise Distribution</p>
            <Bar
              options={options}
              data={{
                labels : ["Kohima", "Dimapur", "Wokha", "Tuensang", "Zunheboto", "Longleng", "Peren", "Mokokchung", "Mon", "Kiphire", "Phek", "Tseminyu"],
                datasets: [
                  {
                    label: ' Number of Candidates District-Wise',
                    data: this.state.districtData,
                    borderColor: 'rgba(13, 96, 160, 1)',
                    backgroundColor: 'rgba(123,185,232,0.6)',
                    borderWidth: 2,
                  }
                ],
              }}
            />
          </div>
        </div>
        <div className="dashbaord_div_5">
          <div className="dashbaord_div_4_inner">
            <p className="dashboard_pie_txt_table">Target Completion Progress</p>
            <div>
              <table className="targetsTable">
                  <thead>
                      <tr>
                        <th>Sl. No</th>
                        <th>Training Programs</th>
                        <th>Targets</th>
                        <th>Trained</th>
                        <th className="progress_mobile_th_hidden">Percentage</th>
                      </tr>
                  </thead>
                  <tbody>
                    <tr>
                          <td>1</td>
                          <td className="boldText">Awareness Workshop</td>
                          <td>1000</td>
                          <td>{this.state.handloomWorkshop}</td>
                          <td className="progress_mobile_th_hidden"><ProgressBar now={this.state.handloomWorkshop_percentage} striped animated  label={this.state.handloomWorkshop_percentage + "%"} /></td>
                      </tr>
                      <tr>
                          <td>2</td>
                          <td className="boldText">&nbsp;Digital Literacy (Basic of computers, internet usage and digital payments)</td>
                          <td>4000</td>
                          <td>{this.state.digitalLiteracy}</td>
                          <td className="progress_mobile_th_hidden"><ProgressBar now={this.state.digitalLiteracy_percentage} striped animated  label={this.state.digitalLiteracy_percentage + "%"} /></td>
                      </tr>
                      <tr>
                          <td>&nbsp;3</td>
                          <td className="boldText">&nbsp;Digital Photography and Scanning</td>
                          <td>400</td>
                          <td>{this.state.digitalPhotography}</td>
                          <td className="progress_mobile_th_hidden"><ProgressBar now={this.state.digitalPhotography_percentage} striped animated  label={this.state.digitalPhotography_percentage + "%"} /></td>
                      </tr>
                      <tr>
                          <td>&nbsp;4</td>
                          <td className="boldText">&nbsp;CAD/CAM technology</td>
                          <td>200</td>
                          <td>{this.state.cad_cam}</td>
                          <td className="progress_mobile_th_hidden"><ProgressBar now={this.state.cad_cam_percentage} striped animated  label={this.state.cad_cam_percentage + "%"} /></td>
                      </tr>
                      <tr>
                          <td>&nbsp;5</td>
                          <td className="boldText">IT based Capacity Building for different crafts</td>
                          <td>940</td>
                          <td>{this.state.it_skills}</td>
                          <td className="progress_mobile_th_hidden"><ProgressBar now={this.state.it_skills_percentage} striped animated  label={this.state.it_skills_percentage+"%"} /></td>
                      </tr>
                      <tr>
                          <td>6</td>
                          <td className="boldText">Entrepreneurship & Soft Skill development</td>
                          <td>380</td>
                          <td>{this.state.entrepreneurship}</td>
                          <td className="progress_mobile_th_hidden"><ProgressBar now={this.state.entrepreneurship_percentage } striped animated  label={this.state.entrepreneurship_percentage + "%"}/></td>
                      </tr>
                      <tr>
                          <td>&nbsp;</td>
                          <td>&nbsp;Total</td>
                          <td>&nbsp;6920</td>
                          <td>{this.state.digitalLiteracy + this.state.digitalPhotography + this.state.cad_cam + this.state.it_skills + this.state.entrepreneurship+ this.state.handloomWorkshop}</td>
                          <td className="progress_mobile_th_hidden"><ProgressBar now={this.state.total_percentage} striped animated variant="success" label={this.state.total_percentage + "%"} /></td>
                      </tr>
                  </tbody>
              </table>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    )}
}
export default withRouter(dashboard);